'use strict'

import Hammer from '../../components/hammer.min'

export default class Header {
  constructor( options )
  {
    this.$elem = $('#header')

    if( this.$elem.length > 0 ){
      let self = this

      this.$buttonToggle = this.$elem.find('.button-collapse')
      this.$buttonSidebar = this.$elem.find('.button-sidebar')
      this.$buttonCloseMenuMobile = this.$elem.find('#mobile-menu .close_button')
      this.$submenuMobile = this.$elem.find('.Header__navigation__mobile__submenu')
      this.$buttonCloseSubMenuMobile = this.$submenuMobile.find('.close_button_submenu')
      this._options = options
      this.isMovingMenuMobile = false

      $(document).ready(function(){
        self._createMenuMobile()
        self._adjustMenuLang()
        self._toggleSubMenu()
        self._crossbrowsing()

        let $currentItemMenu = $('.Header__navigation__mobile__menu').children('.current-menu-parent')
        if( $currentItemMenu.length > 0 ){
          self._loadImageCategory( $currentItemMenu  )
        }

        let $menu_items_sub = $('.Header__navigation__secondary li.menu-item');
        $menu_items_sub.on('click', function (event) {
          if( event.target.href != '#' && event.target.parentElement.className.search('has-children') < 0 ){
            window.location.href = event.target.href
          }
        })

        let $menu_item_with_submenu =  $('.menu-item-has-children')
        $menu_item_with_submenu.on('click', function( event ){
          event.preventDefault()
          event.stopPropagation()

          self._toggleSubMenu( $(this), 'event' )
          self._loadImageCategory( $(this) )
        })

        self.$buttonToggle.on('click', ( event ) => {
          self._openMenu(self, 'open')
        })

        self.$buttonSidebar.on('click', ( event ) => {
          if( !$('#wrapper').siblings('.Sidebar').hasClass('-hover') ){
            $('#wrapper').siblings('.Sidebar').addClass('-hover', 300, 'swing')
            if( $('html').hasClass('safari7') || $('html').hasClass('safari8') || $('html').hasClass('safari9') ){
              $('#wrapper').siblings('.Sidebar').addClass('showed', 300, 'swing')
            }
          } else{
            $('#wrapper').siblings('.Sidebar').removeClass('-hover', 300, 'swing')
            if( $('html').hasClass('safari7') || $('html').hasClass('safari8') || $('html').hasClass('safari9') ){
              $('#wrapper').siblings('.Sidebar').addClass('showed', 300, 'swing')
            }
          }
        })
        if( $('.Sidebar').length == 0 ){
          self.$buttonSidebar.hide()
        }

        self.$buttonCloseMenuMobile.on('click', ( event ) => {
          event.preventDefault()
          event.stopImmediatePropagation()

          self._openMenu(self, 'close')
        })

        self.$buttonCloseSubMenuMobile.on('click', ( event ) => {
          self.$submenuMobile.removeClass('active')
        })

        /*var $elemSwipe = new Hammer(document)
        $elemSwipe.on('swiperight swipeleft', function (e) {
          if( window.innerWidth < 1024 ){
            e.preventDefault()
            
            let $headerMobile = $('#mobile-menu')

            if(e.type == 'swiperight') {
              // to open
              if( !$('.Sidebar').hasClass('show_complete') ) {
                if( !$headerMobile.hasClass('active') ) {
                  self._openMenu(self, 'open')
                }
              }
            } else {
              // to close
              if( $headerMobile.hasClass('active') ) {
                self._openMenu(self, 'close')
              }
            }
          }
        })*/
      })

      if( this._options.fixed ){
        $( window ).scroll( () => { /* this._stickyHeaderBar() */ } );
      }
    }
  }

  _createMenuMobile()
  {
    let $menuMobile = $('#mobile-menu'),
        $itemsMenuFirst = $menuMobile.siblings('ul').last().children(),
        $itemsMenuSecond = $menuMobile.siblings('ul').first().children(),
        items = []

    $.each($itemsMenuFirst, function( i,val ){
      let clone = $(this).clone()
      items.push( clone )
    })

    $.each($itemsMenuSecond, function( i,val ){
      let clone = $(this).clone()
      items.push( clone )
    })

    $.each(items, function( i,val ){
      $menuMobile.children('.Header__navigation__mobile__menu').append( $(this) )
    })
  }

  _openMenu( _this, action )
  {
    let $mobileMenu = $('#mobile-menu'),
        open = function( elem ){
          _this.$elem.addClass('open-menu')
          elem.addClass('active')

          elem.transition(
              {
                x: 0
              },
              500,
              'linear'
          )

          setTimeout(function(){
            _this.isMovingMenuMobile = false
          }, 500)
        },
        close = function( elem ){
          _this.$elem.removeClass('open-menu')

          elem.transition(
              {
                x: `-${( elem.outerWidth() * 1.1 )}`
              },
              500,
              'linear'
          )

          setTimeout(function(){
            _this.isMovingMenuMobile = false
            elem.removeClass('active')
          }, 500)
        }

    if( !_this.isMovingMenuMobile ){
      this.isMovingMenuMobile = true

      if( typeof action != 'undefined' ){
        if( action == 'open' ){
          open( $mobileMenu )
        } else if( action == 'close' ){
          close( $mobileMenu )
        }
      } else{
        if( _this.$elem.hasClass('open-menu') ){
          open( $mobileMenu )
        }
        else{
          close( $mobileMenu )
        }
      }
    }
  }

  _toggleSubMenu( elem, type )
  {
    if( typeof elem == 'undefined' ){
      elem = $('#menu-secondary-menu').find('.current-menu-parent')
    }

    let $containerSubmenu = $('.Header__navigation__mobile__submenu'),
        $currentSubmenu = elem.children('ul').children().clone()

    $containerSubmenu.children('ul').html('')
    $containerSubmenu.children('ul').append($currentSubmenu)
    $containerSubmenu.children('ul').children().addClass('animated fadeInLeft')

    if( type == 'event' ){
      $containerSubmenu.addClass('active')
    }
  }

  _adjustMenuLang( )
  {
    let $menuLangs = $('.lang_sel_list_horizontal ul')

    $.each($menuLangs.children(), function( i, val ){
      let value = $(this).children().text()

      switch ( value ) {
        case "Español":
          value = "Esp"
          break
        case "English":
          value = "En"
          break
      }

      $(this).children().text(value)
    })
  }

  _stickyHeaderBar( )
  {
    let $scrollWindow = $(window).scrollTop(),
        self = this

    if( $scrollWindow > 0 ){
      if( !self.$elem.hasClass('sticky') ){
        self.$elem.addClass('sticky')
      }
    }
    else{
      if( self.$elem.hasClass('sticky') ){
        self.$elem.removeClass('sticky')
      }
    }
  }

  _loadImageCategory( elem )
  {
      var $this = elem

      var url = elem.find('a').attr('href')
      var url = url.split("/")
      var slug = url[4]
      var taxonomy = ''
      $('.imgmenu').hide()
      $('.'+slug).show()
  }

  _crossbrowsing()
  {
    if( $('html').hasClass('win') && $('html').hasClass('gecko') ){
      $('.Header__social').removeClass('col').addClass('col-1')
    }
  }
}
